import { render, staticRenderFns } from "./Produce.vue?vue&type=template&id=65ee63f4&scoped=true"
import script from "./Produce.vue?vue&type=script&lang=js"
export * from "./Produce.vue?vue&type=script&lang=js"
import style0 from "./Produce.vue?vue&type=style&index=0&id=65ee63f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ee63f4",
  null
  
)

export default component.exports